module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.linkTag, _vm._b({
    tag: "component",
    class: _vm.linkClass,
    on: {
      "click": _vm.onClick
    }
  }, 'component', _vm.linkProps, false), [(_vm.icon && !_vm.iconNegative) ? _c('module-icon', {
    class: [
      "link__icon",
      "link__icon--positive" ],
    attrs: {
      "icon": _vm.icon
    }
  }) : _vm._e(), ((_vm.$slots.default || [])[0]) ? _vm._t("default") : [_vm._v(_vm._s(_vm.labelSet))], (_vm.icon && _vm.iconNegative) ? _c('module-icon', {
    class: [
      "link__icon",
      "link__icon--negative" ],
    attrs: {
      "icon": _vm.icon
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aadab054"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Link.vue
// module id = 89
// module chunks = 3